import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import {ICom0101MState, IApprListState, IInquiryCndsState, IUserItemState, IApprDcdState, IApprStCdState} from '../../models/com/com0101m_model';
  
const initialState: ICom0101MState = {
    apprList : [],      // 결재목록

    inquiryCnds: {
        reqStDt: '',
        reqEdDt: '',
    },    // 조회조건
    userList : [],      // 사용자목록
    apprDcdList: [],    // 결재종류코드
    apprStCdList: [],   // 결재상태코드
    
    pageSize  : 20,     // 페이징건수
    current   : 0,      // 현재페이지
}

export const com0101m_Slice = createSlice({
    name: "com0101m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , userList: state.userList
                                   , apprDcdList: state.apprDcdList
                                   , apprStCdList: state.apprStCdList});
        },
        setApprList: (state, action:PayloadAction<IApprListState[]>) => {
            state.apprList = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setApprDcdList: (state, action:PayloadAction<IApprDcdState[]>) => {
            state.apprDcdList = action.payload;
        },
        setApprStCdList: (state, action:PayloadAction<IApprStCdState[]>) => {
            state.apprStCdList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default com0101m_Slice.reducer;
export const Com0101mAction  = com0101m_Slice.actions;
export const Com0101mReducer = com0101m_Slice.reducer;